/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chatemptyexample2Inputs */

const en_chatemptyexample2 = /** @type {(inputs: Chatemptyexample2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`"On March 12, 2024 we signed a €15,000 quote for the kitchen renovation."`)
};

const pt_chatemptyexample2 = /** @type {(inputs: Chatemptyexample2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`"A 12 de março de 2024 assinámos um orçamento de €15.000 para a remodelação da cozinha."`)
};

/**
* | output |
* | --- |
* | "\"On March 12, 2024 we signed a €15,000 quote for the kitchen renovation.\"" |
*
* @param {Chatemptyexample2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const chatemptyexample2 = /** @type {((inputs?: Chatemptyexample2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chatemptyexample2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chatemptyexample2(inputs)
	return pt_chatemptyexample2(inputs)
});
export { chatemptyexample2 as "chatEmptyExample" }